import { render, staticRenderFns } from "./login copy.vue?vue&type=template&id=f0627850"
import script from "./login copy.vue?vue&type=script&lang=js"
export * from "./login copy.vue?vue&type=script&lang=js"
import style0 from "./login copy.vue?vue&type=style&index=0&id=f0627850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports